module.exports = __webpack_public_path__ + "img/feedback_1.30acf78d.png";